<template>
  <TopPanel>
    <div class="flex flex-center fl-jc-sb fl-1">
      <BreadCrumbs :items="items" />
      <div class="flex flex-center">
        <div class="hint" @click="visible = true">
          Как скачать данные дашборда в формате XLSX?
        </div>
        <div
          :title="
            !props.isDashboardSelected
              ? 'Сначала выберите дашборд'
              : 'Развернуть дашборд на весь экран'
          "
        >
          <Button
            :disabled="!props.isDashboardSelected"
            @click="$emit('expandDashboard')"
            icon="pi pi-window-maximize"
            label="Во весь экран"
            class="expand-button"
            :pt="{
              root: {
                style: 'min-width: 150px; white-space: nowrap; height: 32px',
              },
            }"
          />
        </div>
      </div>
    </div>
    <DownloadDashboardDialog
      :visible="visible"
      @close="visible = false"
    ></DownloadDashboardDialog>
  </TopPanel>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import DownloadDashboardDialog from "@/shared/dialogs/DownloadDashboardDialog.vue";
import Button from "primevue/button";

const props = defineProps<{
  nameDashbords: string;
  isDashboardSelected?: boolean;
}>();
const emit = defineEmits([
  "setCommonFilter",
  "toggleArchive",
  "toggleFilter",
  "createAction",
  "expandDashboard",
]);

const searchField = ref(null);
const debounceTimeout = ref(0);

const sendItemRequest = () => {
  emit("setCommonFilter", searchField.value);
};

const visible = ref(false);

watch(
  () => searchField.value,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 400);
  },
  { immediate: true }
);

const items = ref([
  { label: "Аналитика", archive: "both" },
  { label: props.nameDashbords, archive: "both" },
]);
</script>

<style lang="scss" scoped>
.hint {
  margin-right: 20px;
  cursor: pointer;
  color: #a19cab;
  padding-bottom: 0.5px;
  border-bottom: 1px dotted #a19cab;

  &:hover {
    color: $main-link-color;
    border-bottom-color: $main-link-color;
  }
}

.expand-button {
  margin-left: 12px;
  margin-right: 20px;
}
</style>
